import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import SecondaryButton from 'components/elements/Form/button/secondaryButton';
import IntegrationKeyService, { IntegrationKeyProps } from 'services/hooks/integration-key-service';
import LoadingSpinner from 'components/elements/Spinner/LoadingSpinner';
import { Table } from '../Common/Table';
import Save from './IntegrationKeyForms/save';
import Delete from './IntegrationKeyForms/delete';
import { FilterSelect } from 'utils/FilterSelectUtils';
import IntegrationService, { IntegrationProps } from 'services/hooks/integration-service';
import { IntegrationPreferenceProps } from 'services/hooks/integration-preference-service';

export default function IntegrationKeysSaveMode() {
  const [getIntegrationKeysResult, setGetIntegrationKeysResult] = useState<
    IntegrationKeyProps[] | null
  >([]);
  const [integrationsList, setIntegrationsList] = useState<IntegrationProps[] | null>();

  const {
    isLoading: isLoadingIntegrationKeys,
    refetch,
    data: integrationKeysData
  } = useQuery<IntegrationKeyProps[], Error>('keys', IntegrationKeyService.findAllIntegrationKeys, {
    onError: (err: any) => {
      console.log(err.response?.data || err);
    }
  });

  const { refetch: integrationRefetch, data: integrationData } = useQuery<
    IntegrationProps[],
    Error
  >('integrations', IntegrationService.findAllIntegrations, {
    onError: (err: any) => {
      console.log(err.response?.data || err);
    }
  });

  useEffect(() => {
    if (integrationKeysData && Array.isArray(integrationKeysData)) {
      refetch();
      setGetIntegrationKeysResult(integrationKeysData);
    }
    if (integrationData && Array.isArray(integrationData)) {
      integrationRefetch();
      setIntegrationsList(integrationData);
    }
  }, [integrationKeysData, refetch, integrationData, integrationRefetch]);

  const columns = React.useMemo(
    () => [
      {
        id: 'integrationname',
        Header: 'Integration Name',
        accessor: (row: { preferenceUuid: string }) => {
          return integrationsList?.find(
            (f: { preferences?: IntegrationPreferenceProps[] | any }) =>
              f?.preferences?.uuid === row?.preferenceUuid
          )?.name;
        },
        Filter: FilterSelect
      },
      {
        id: 'clientid',
        Header: 'Client Id',
        accessor: (row: { clientId: string }) => {
          return `${row?.clientId}`;
        },
        width: 500,
        disableFilters: true
      },
      {
        id: 'clientsecret',
        Header: 'Client Secret',
        accessor: (row: { clientSecret: string }) => {
          return `${row?.clientSecret}`;
        },
        width: 500,
        disableFilters: true
      },
      {
        id: 'keyType',
        Header: 'Key Type',
        accessor: (row: { keyType: string }) => {
          return `${row?.keyType}`;
        },
        width: 500,
        disableFilters: true
      },
      {
        id: 'actions',
        Header: 'Actions',
        accessor: (data: any) => data,
        Cell: (row: any) => {
          return (
            <div className="flex gap-4">
              <SecondaryButton
                onClick={() => {
                  row.setEditUUID(row.value.uuid);
                  row.setUpdateShowModal(true);
                }}
                buttonLabel="Edit"
                variant="default"
                size="px-4 w-auto"
              />
              <SecondaryButton
                onClick={() => {
                  row.setDeleteUUID(row.value.uuid);
                  row.setDeleteShowModal(true);
                }}
                buttonLabel="Delete"
                variant="default"
                size="px-4 w-auto"
              />
            </div>
          );
        },
        width: 150,
        disableFilters: true
      }
    ],
    [integrationsList]
  );

  if (isLoadingIntegrationKeys || !getIntegrationKeysResult) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return !isLoadingIntegrationKeys && getIntegrationKeysResult ? (
    <div className="keys">
      <Table
        name="Keys"
        columns={columns}
        data={getIntegrationKeysResult}
        refetch={refetch}
        CreateForm={Save}
        DeleteForm={Delete}
        createQuery={IntegrationKeyService.createIntegrationKey}
        updateQuery={IntegrationKeyService.updateIntegrationKey}
        deleteQuery={IntegrationKeyService.deleteIntegrationKeyById}
        editQuery={IntegrationKeyService.findIntegrationKeyById}
        queryName="keys"
        buttonName="Key"
        toolTipMessage="Manage keys for integrations."
      />
    </div>
  ) : (
    <div>
      <LoadingSpinner />
    </div>
  );
}
